import { FormControl, FormHelperText } from "@mui/material";
import { useTranslation } from "react-i18next";
import { FoodsSelect } from "@foodpilot/foods";
import { DataListOption } from "src/api/sure-api/dataList/useGetAllDataList";

interface DataListOptionAutocompleteProps {
    options: DataListOption[];
    value: DataListOption | null;
    onChange: (option: DataListOption | null) => void;
    placeholder?: string;
    disabled?: boolean;
    error?: boolean;
    helperText?: string;
}

export function DataListOptionAutocomplete({
    options,
    value,
    onChange,
    placeholder,
    disabled = false,
    error = false,
    helperText,
}: DataListOptionAutocompleteProps) {
    const { t } = useTranslation();

    return (
        <FormControl fullWidth error={error}>
            <FoodsSelect
                selectedOption={value}
                options={options}
                onChange={(option) => onChange(option ?? null)}
                getId={(option: DataListOption) => option.id}
                getName={(option: DataListOption) => option.label || option.code}
                closeOnSelect
                disabled={disabled}
                textOptions={{
                    placeholder: placeholder || t("data_list.option.select.placeholder", "Select a data list option"),
                    searchPlaceholder: t("data_list.option.select.searchPlaceholder", "Search options..."),
                    emptyOptionsText: t("data_list.option.select.noOptions", "No options available"),
                    defaultValueText: t("data_list.option.select.defaultValue", "Default value"),
                    noResult: t("data_list.option.select.noResultFound", "No options found"),
                }}
                BoxProps={{ width: "100%" }}
            />
            {helperText ?
                <FormHelperText>{helperText}</FormHelperText>
            :   null}
        </FormControl>
    );
}
